import { render, staticRenderFns } from "./kdropdownmenu.vue?vue&type=template&id=0b27b030&scoped=true"
import script from "./kdropdownmenu.vue?vue&type=script&lang=js"
export * from "./kdropdownmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b27b030",
  null
  
)

export default component.exports